import React from "react";
import {FormattedMessage} from "react-intl";
import classes from "./styles.module.css";

const Empty = () => {
    return (
        <tr className={classes.EmptyRow}>
            <td colSpan="6">
                <div className={classes.Empty}>
                    <h5>
                        <FormattedMessage id="ContractsTable.empty" defaultMessage="Нет контрактов"/>
                    </h5>
                </div>
            </td>
        </tr>
    );
};

export default Empty;



// WEBPACK FOOTER //
// ./src/Components/ContractsTable/Empty.js